module.exports = __webpack_public_path__ + "static/img/01.4f34f405.png";